import { type SingleSelectedValueFilter } from '../types'
import DateFilter from './DateFilter'

const AfterDateFilter = (props: SingleSelectedValueFilter) => {
  return <DateFilter {...props} rangeType='Greater than' />
}

export default AfterDateFilter
